import React from "react";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

import { getSeries } from "./utils";

const BarGraph = ({ data }) => {
  const getCategories = (data) => {
    return Object.values(data)[0];
  };
  const categories = getCategories(data);

  const series = getSeries(data);
  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: "Bar Chart",
      align: "left",
    },
    xAxis: {
      categories: categories,
    },
    yAxis: {
      // min: 0,
      // title: {
      //   text: "Count trophies",
      // },
      // stackLabels: {
      //   enabled: true,
      // },
    },
    legend: {
      align: "right",
      x: 0,
      verticalAlign: "top",
      y: 0,
      floating: true,
      backgroundColor:
        Highcharts.defaultOptions.legend.backgroundColor || "white",
      borderColor: "#CCC",
      borderWidth: 1,
      shadow: false,
    },
    tooltip: {
      useHTML: true,
      formatter: function () {
        return `<div style="display: flex; flex-direction: column;">
        <div style="font-weight: 600">${this.key}</div>
        <div>${this.series.name}: ${this.point.y.toLocaleString("en-US")}</div>
        <div>Total: ${this.point.stackTotal.toLocaleString("en-US")}</div>
        </div>`;
      },
    },
    plotOptions: {
      series: {
        minPointLength: 10,
      },
      column: {
        stacking: "normal",
        // dataLabels: {
        //   enabled: true,
        // },
      },
    },
    series,
  };

  if (!series.length)
    return (
      <div>
        It seems there's no data available for the current query. If you have
        another question or need assistance with a different topic, please feel
        free to ask, and I'll do my best to help you.
      </div>
    );

  return categories?.length > 1 ? (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  ) : (
    <></>
  );
};

export default BarGraph;
